
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TeamCredentialModel } from './Identity.Api.Models.TeamCredential';
import { TeamCustomCredentialModel } from './Identity.Api.Models.TeamCustomCredential';
import { UserTeamModel } from './Identity.Api.Models.UserTeam';
import { TeamDashboardElementModel } from './Identity.Api.Models.TeamDashboardElement';
import { Model, ModelProperty } from 'models/Model';


export class TeamModel extends Model<TeamModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'team.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'team.property.name' },
		{ name: 'created', type: 'Date', languageString: 'team.property.created', isHidden: true },
		{ name: 'deleted', type: 'Date', languageString: 'team.property.deleted', isHidden: true },
		{ name: 'sale', type: 'boolean', languageString: 'team.property.sale' },
		{ name: 'salesBrandId', type: 'guid', languageString: 'team.property.salesBrandId' },
		{ name: 'teamCredentials', type: 'TeamCredentialModel[]', languageString: 'team.property.teamCredentials', isHidden: true, isArray: true, isObject: true, new: () => { return new TeamCredentialModel }, properties: () => { return TeamCredentialModel.classProperties } },
		{ name: 'teamCustomCredentials', type: 'TeamCustomCredentialModel[]', languageString: 'team.property.teamCustomCredentials', isHidden: true, isArray: true, isObject: true, new: () => { return new TeamCustomCredentialModel }, properties: () => { return TeamCustomCredentialModel.classProperties } },
		{ name: 'userTeams', type: 'UserTeamModel[]', languageString: 'team.property.userTeams', isHidden: true, isArray: true, isObject: true, new: () => { return new UserTeamModel }, properties: () => { return UserTeamModel.classProperties } },
		{ name: 'teamDashboardElements', type: 'TeamDashboardElementModel[]', languageString: 'team.property.teamDashboardElements', isHidden: true, isArray: true, isObject: true, new: () => { return new TeamDashboardElementModel }, properties: () => { return TeamDashboardElementModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public created?: Date;
	public deleted?: Date;
	public sale: boolean;
	public salesBrandId?: string;
	public teamCredentials: TeamCredentialModel[];
	public teamCustomCredentials: TeamCustomCredentialModel[];
	public userTeams: UserTeamModel[];
	public teamDashboardElements: TeamDashboardElementModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.created = undefined;
		this.deleted = undefined;
		this.sale = false;
		this.salesBrandId = undefined;
		this.teamCredentials = [];
		this.teamCustomCredentials = [];
		this.userTeams = [];
		this.teamDashboardElements = [];
		
	}
	getProperties(){
		return TeamModel.classProperties;
	}
}

